// Coarse "time until" formatter (task-17-brief.md: "~4m" / "~2h 10m" style) — shared by the
// Habitat play-cooldown label and, per the brief, Task 18's shop-restock/forage clocks. C3 "no
// urgency": deliberately coarse (minutes at finest grain, no seconds) so a countdown never reads
// as a ticking clock — a companion/shop is either ready or it isn't, and the player learns
// roughly when, not to the second.
//
// Task 20 widening: a day-plus gap (e.g. JournalDto.weeklyResetAt, up to a week out) rounds to a
// single "~Xd" — one more step of the SAME coarsening this function already applies at the hour
// boundary (dropping the sub-hour "Xm" once past 60 minutes), never "~1d 3h": C3's "no urgency"
// reasoning gets stronger, not weaker, the further out the target is.
export function formatEta(iso: string, now: Date = new Date()): string {
  const diffMs = new Date(iso).getTime() - now.getTime();
  // Floors at "~1m" rather than "~0m"/negative — a target in the past-or-imminent still reads as
  // "about to be ready," never a confusing zero or negative duration (clock skew, or the instant
  // between the server's playReadyAt and this render).
  const totalMinutes = Math.max(1, Math.round(diffMs / 60000));

  if (totalMinutes < 60) return `~${totalMinutes}m`;

  const totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 24) {
    const minutes = totalMinutes % 60;
    return minutes === 0 ? `~${totalHours}h` : `~${totalHours}h ${minutes}m`;
  }

  const days = Math.round(totalMinutes / 1440);
  return `~${days}d`;
}
